import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const Preferences = ({ preferences }) => (
  <Grid gap="0">
    <H2 variant="primary" profile>
      Preferences
    </H2>
    {preferences.length > 0 ? (
      <Grid gap="8px">
        {preferences.map((preference, index) => (
          <div key={`preference_${index}`}>
            <P marginless variant="content" profileData>
              - {preference.name}
            </P>
          </div>
        ))}
      </Grid>
    ) : (
      <P marginless profileData>
        No preferences set.
      </P>
    )}
  </Grid>
)

Preferences.propTypes = {
  preferences: PropTypes.array.isRequired
}

Preferences.defaultProps = {
  preferences: []
}

export default Preferences
